import React from "react";
import Link from "next/link";
import PropTypes from "prop-types";
import styles from "./footer.module.scss";
import DeferredIcon from "../../../components/deferred-icon/DeferredIcon";
import { ConditionalWrapper } from "../../../lib/helpers";

const LinksCol = ({ links }) => {
  return (
    <div className={styles.linkCol}>
      {links.map(
        ({
          iconProps,
          link,
          label,
          textColor,
          disableClientSideNav,
          onClick,
        }) => (
          <ConditionalWrapper
            key={label}
            condition={disableClientSideNav}
            wrapper={(children) => (
              <a href={link} className={styles.link}>
                {children}
              </a>
            )}
            elseWrapper={(children) => {
              return (
                <Link href={link} passHref>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    onClick={() => {
                      onClick && onClick();
                    }}
                    className={styles.link}
                  >
                    {children}
                  </a>
                </Link>
              );
            }}
          >
            {!!iconProps && (
              <div className={styles.iconContainer}>
                <DeferredIcon alt={label} {...iconProps} />
              </div>
            )}
            <div className={styles.label} style={{ color: textColor || "" }}>
              {label}
            </div>
          </ConditionalWrapper>
        )
      )}
    </div>
  );
};

LinksCol.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      iconProps: PropTypes.shape({
        type: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
      }),
    })
  ),
};

LinksCol.defaultProps = {
  links: [],
};

export default LinksCol;
